import {forwardRef, useContext} from 'react';
import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';
import { useSettingsContext } from 'src/components/settings';
import postgradlogo from 'src/assets/logo_postgrad.svg';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ border = false, disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();

  const settings = useSettingsContext();
  
  const logo = ( <>
    {
      settings.themeLayout === "vertical"
      ? <Box
          ref={ref}
          component="div"
          sx={{
            minWidth: '2.4rem',
            maxWidth: '2.4rem',
            ml: !border ? "10px" : "0px",
            pb: !border ? "15px" : "0px",
            display: 'inline-flex',
            ...sx,
          }}
          {...other}
        >
          <img src={postgradlogo} alt="Postgrad logo" />
        </Box>

      : <Box
          ref={ref}
          component="div"
          sx={{
            minWidth: '1.9125rem',
            maxWidth: '1.9125rem',
            display: 'inline-flex',
            ...sx,
          }}
          {...other}
        >
          <img src={postgradlogo} alt="Postgrad logo" />
        </Box>
      
    }
    </>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  isNavMini: PropTypes.bool,
  border: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
